export default __webpack_public_path__ + "static/cutout-ffddaf4b3377c75b470caba28669a507.png";